// Missing/blank/unparseable timestamps return "" (a blank cell) rather than the
// literal "Invalid Date" — e.g. a user who has never logged in has no lastLogin.
export function formatToLocalDateTime(timestamp, timezone) {
    if (timestamp === null || timestamp === undefined || timestamp === '') return '';
    const date = new Date(timestamp);
    if (isNaN(date.getTime())) return '';
    try {
        return date.toLocaleString("en-US", {
            timeZone: timezone,
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: true
        });
    } catch (error) {
        console.error("Invalid timestamp or timezone:", error);
        return '';
    }
}

export function formatToLocalDate(timestamp, timezone) {
    if (timestamp === null || timestamp === undefined || timestamp === '') return '';
    const date = new Date(timestamp);
    if (isNaN(date.getTime())) return '';
    try {
        return date.toLocaleDateString("en-US", { timeZone: timezone });
    } catch (error) {
        console.error("Invalid timestamp or timezone:", error);
        return '';
    }
}

export function getCurrentDateInTimezone(timezone = 'UTC') {
    try {
        // Create a date string in the target timezone
        const now = new Date();
        const dateString = now.toLocaleString("en-US", { timeZone: timezone });
        return new Date(dateString);
    } catch (error) {
        console.error("Invalid timezone:", error);
        return new Date(); // fallback to current date
    }
}

export function isWithinLastHours(dateString, hours = 1) {
    if (!dateString) return false;
    const date = new Date(dateString);
    const now = new Date();
    const diffInMinutes = (now - date) / (1000 * 60);
    return diffInMinutes <= (hours * 60);
}

export function isOlderThanHours(dateString, hours = 24) {
    if (!dateString) return true;
    const date = new Date(dateString);
    const now = new Date();
    const diffInHours = (now - date) / (1000 * 60 * 60);
    return diffInHours > hours;
} 
